import React from "react";
import {
  Link
} from "react-router-dom";
import config from './../config.js';
import Notification from 'rc-notification';
import Modal from './../../components/modal.js';
import Loading from './../../components/loading.js';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class Myprojects extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
    }
    //console.log(user);
    this.state = {
      page_title: '我的项目',
      page_subtitle: ' My Projects',
      title: '删除确认',
      message: '确定要删除这个项目吗？',
      display: false,
      loading: false,
      target: null,
      projectid: null,
      modaltype: 'delete',
      userid: user.id,
      companyid: user.company_id,
      level: user.level,
      user: user,
      myprojects: [],
      projectedit: false,
      project: {
        id: 0,
        name: '',
        description: '',
        machine: '',
        operator: '',
        statue: '',
        update_time: '',
        user_id: '',
        group: []
      },
      shareprojects: []
    };
    document.title = this.state.page_title + this.state.page_subtitle;
    this.close = this.close.bind(this);
    this.submit = this.submit.bind(this);
    this.modal = this.modal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

  }



  componentDidMount() {
    this.getMyproject();
    this.getShareProject();
  }



  handleInputChange(event) {
    const target = event.target;
    //const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const value = target.value;
    const project = this.state.project;
    Object.assign(project, {
      [name]: value
    });
    this.setState(project);
  }



  modal(e) { //modal for delete
    this.setState({
      target: e.target,
      projectid: e.target.id,
      modaltype: 'delete',
      display: true,
      title: '删除确认',
      message: '确定要删除 ' + e.target.name + ' 这个项目吗？',
      projectedit: false
    });
  }



  projectmodal(id) { //modal for project edit
    const me = this;
    if (id > 0) {
      let project = me.state.myprojects.filter((d, i) => {
        return d.id === id;
      });
      //console.log(project[0]);
      me.setState({
        project: project[0]
      });
    }

    this.setState({
      display: true,
      modaltype: id > 0 ? 'edit' : 'create',
      title: id > 0 ? '编辑项目' : '创建新项目',
      message: null,
      projectedit: true
    });
  }



  close() { //modal close
    this.setState({
      display: false,
      projectform: null,
      message: null,
      title: null,
      projectedit: false,
      loading: false,
      project: {
        id: 0,
        name: '',
        description: '',
        machine: '',
        operator: '',
        statue: '',
        update_time: '',
        user_id: '',
        group: []
      }
    });
  }



  submit() {
    const me = this;
    switch (me.state.modaltype) {
      case 'delete':
        me.removeProject();
        break;
      default:
        me.postProject();
        break;
    }
  }



  postProject() {
    const me = this;

    if (me.state.project.name === '') {
      me.notify('请输入项目名称');
      return;
    }

    me.setState({
      loading: true
    });
    const postdata = Object.assign({
      level: me.state.level,
      companyid: me.state.companyid,
      userid: me.state.userid,
      Authorization: localStorage.token,
      post_type: 'update'
    }, me.state.project);

    console.log(config.host)
    fetch(config.host + '/myprojects/index/', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(response => response.json())
      .then(json => {
        if (json.status === '1') {
          const myprojects = me.state.myprojects;
          if (me.state.project.id === 0) {
            const project = Object.assign(me.state.project, json.data);
            //myprojects.push(project);
            //myprojects.sort();
            myprojects.splice(0, 0, project);
            me.setState({
              myprojects: myprojects
            });
          }

          me.close();

          me.notify('提交成功');
        } else {
          me.setState({
            loading: false
          });
          me.notify(json.message);
        }

      })
      .catch(function(error) {
        console.log(error);
      });
  }



  removeProject() {
    const me = this;
    const {
      companyid,
      userid,
      level,
      projectid
    } = me.state;
    const postdata = {
      companyid: companyid,
      userid: userid,
      level: level,
      projectid: projectid,
      post_type: 'delete',
      Authorization: localStorage.token
    };
    fetch(config.host + '/myprojects/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const myprojects = me.state.myprojects;
          for (let index in myprojects) {
            if (myprojects[index].id === me.state.projectid) {
              delete myprojects[index];
            }
          }
          //console.log(myprojects);
          me.setState({
            myprojects: myprojects,
            display: false,
            loading: false,
          });
        } else {
          me.setState({
            loading: false,
          });
        }
        me.notify(json.message);
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  getMyproject() {
    const me = this;
    const {
      companyid,
      userid,
      level
    } = me.state;
    const postdata = {
      companyid: companyid,
      userid: userid,
      level: level,
      post_type: 'getmyproject',
      Authorization: localStorage.token
    };
    fetch(config.host + '/myprojects/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            myprojects: data
          }); //Object.assign({},data)
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  getShareProject() {
    const me = this;
    const {
      companyid,
      userid,
      level
    } = me.state;
    const postdata = {
      companyid: companyid,
      userid: userid,
      level: level,
      post_type: 'getshareproject',
      Authorization: localStorage.token
    };
    fetch(config.host + '/myprojects/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            shareprojects: data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  notify(message) {
    notification.notice({
      content: <span>{message}</span>,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }



  render() {
    return (
      <div>
        <Loading display={this.state.loading} classtype="" />
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 ">
          <h3>{this.state.page_title} <small>{this.state.page_subtitle}</small></h3>
          <button type="button" className="btn  btn-outline-success btn-sm float-right" onClick={this.projectmodal.bind(this,0)}><i className="fa fa-plus"></i> 创建新项目</button>
        </div>
        <div className="row">
        {
          this.state.myprojects.map((item,index)=>{
            return (
            <div className="col-6 rounded animated fadeInLeft" key={index}>
              <div className="card mb-4 shadow">
                <div className="card-header bg-transparent">
                  <Link to={`/console/myprojects/project/${item.id}/0`}> <strong> {item.name} </strong></Link>
                  <small className="float-right"><a  onClick={this.modal} id={item.id} name={item.name}>&times;</a></small>
                </div>
                <div className="card-body">
                  <p className="card-text">
                    数据分组：
                    {
                      item.group.map((g,i)=>{
                        return (
                          <span className="badge badge-light" title={g.description} id={g.id}  key={i}> {g.name} </span>
                        )
                      })
                    }

                  </p>
                  <p className="card-text">
                  <small className="text-muted">项目描述：{item.description}</small>
                  <br />
                  <small className="text-muted">机器型号：{item.machine}</small>
                  <br />
                  <small className="text-muted">操作员：{item.operator}</small>
                  </p>

                </div>
                <div className="card-footer bg-transparent">
                  <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <Link to={`/console/myprojects/project/${item.id}/0`} className="btn btn-sm btn-outline-secondary">查看</Link>
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={this.projectmodal.bind(this,item.id)}>修改</button>
                      </div>
                      <small className="text-muted">{item.update_time}</small>
                    </div>
                </div>
            </div>
          </div>
          )
          })
        }
        </div>
        <div className="row">
        {
          this.state.shareprojects.map((item,index)=>{
            return (
            <div className="col-6 rounded" key={index}>
              <div className="card mb-4 shadow">
                <div className="card-header bg-transparent border border-top-0 border-left-0 border-right-0 border-bottom border-success">
                  <Link to={`/console/myprojects/project/${item.id}/MR`}> <strong> {item.name} </strong></Link>
                  <small className="float-right text-success">共享项目</small>
                </div>
                <div className="card-body">
                  <p className="card-text">
                    数据分组：
                    {
                      item.group.map((g,i)=>{
                        return (
                          <span className="badge badge-light mx-1" title={g.description} id={g.id}  key={i}> {g.name} </span>
                        )
                      })
                    }

                  </p>
                  <p className="card-text">
                  <small className="text-muted">项目描述：{item.description}</small>
                  <br />
                  <small className="text-muted">机器型号：{item.machine}</small>
                  <br />
                  <small className="text-muted">操作员：{item.operator}</small>
                  </p>

                  <p>
                    邀请人：{item.inviter.realname || item.inviter.email} {item.inviter.title} {item.inviter.address} {item.inviter.office}
                  </p>

                </div>
                <div className="card-footer bg-transparent">
                  <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <Link to={`/console/myprojects/project/${item.id}/MR`} className="btn btn-sm btn-outline-secondary">查看</Link>
                      </div>
                      <small className="text-muted">{item.update_time}</small>
                    </div>
                </div>
            </div>
          </div>
          )
          })
        }

        </div>

        <Modal title={this.state.title} display={this.state.display} close={this.close} submit={this.submit}>
          {
            this.state.projectedit &&

                  <form className="pr-4">
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label text-right">项目名称：</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.project.name} onChange={this.handleInputChange} placeholder="Project Name" name="name" required />
                        <input type="hidden" value={this.state.project.id} name="id"  />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label text-right">项目描述：</label>
                      <div className="col-sm-8">
                        <textarea className="form-control" rows="3" value={this.state.project.description} onChange={this.handleInputChange} placeholder="Description" name="description"></textarea>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label text-right">机器型号：</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.project.machine} onChange={this.handleInputChange} placeholder="Machine" name="machine" />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label text-right">操作员姓名：</label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.project.operator} onChange={this.handleInputChange} placeholder="Operator" name="operator" />
                      </div>
                    </div>
                  </form>

          }

          {
            !this.state.projectedit && <span>{this.state.message}</span>
          }
        </Modal>

      </div>
    );
  }
}

export default Myprojects


// WEBPACK FOOTER //
// ./src/apps/console/myprojects.js